import { ReactNode } from "react";

interface SearchBaseProps {
  title: string;
  children: ReactNode;
  "aria-live"?: "off" | "polite" | "assertive";
}

export function SearchBase({ title, children, ...props }: SearchBaseProps) {
  return (
    <div className="w-full px-4 py-3" {...props}>
      <h3 className={`text-sm font-600 mb-1 text-secondary-title`}>{title}</h3>

      <div className="flex flex-col gap-4">{children}</div>
    </div>
  );
}
